import React from 'react';
import Slider from 'react-slick';
import './index.css'; // Import CSS for this component (optional)
import { useNavigate } from 'react-router-dom';

const countryData = [
  {
    name: 'United States',
    image: 'https://www.planetware.com/wpimages/2018/12/washington-dc-attractions-united-states-capitol.jpg', // Replace with actual image path
    highlights: ['World-Leading Universities', 'Diverse Culture', 'Vibrant Campus Life'],
  },
  {
    name: 'United Kingdom',
    image: 'https://www.travelonline.com/england/london/attractions/big-ben-in-westminster-40493.jpg', // Replace with actual image path
    highlights: ['Historic Institutions', 'Global Research Hub', 'Multicultural Society'],
  },
  {
    name: 'Canada',
    image: 'https://tse1.mm.bing.net/th/id/OIP.A37NgwnQiuD7iUay-PRq6AHaE6?rs=1&pid=ImgDetMain', // Replace with actual image path
    highlights: ['High Quality of Life', 'Welcoming Environment', 'Affordable Options'],
  },
  {
    name: 'Australia',
    image: 'https://tse3.mm.bing.net/th/id/OIP.oJTGkID3x7Jfp_AsKO5H4QHaE7?rs=1&pid=ImgDetMain', // Replace with actual image path
    highlights: ['Unique Lifestyle', 'Top-Ranked Programs', 'Beautiful Landscapes'],
  },
  {
    name: 'Germany',
    image: 'https://www.tripsavvy.com/thmb/e5KlBWJztZcJLU2lHTukGJQhfto=/4207x2367/filters:no_upscale():max_bytes(150000):strip_icc()/brandenburg-gate-at-sunset-549093677-58f4c1a75f9b582c4dab2824.jpg', // Replace with actual image path
    highlights: ['Tuition-Free Options', 'Strong Engineering', 'Central European Location'],
  },
  {
    name: 'France',
    image: 'https://exploringthenetherlands.com/wp-content/uploads/2022/09/Things-to-do-in-Rotterdam.jpg', // Replace with actual image path
    highlights: ['International Focus', 'English-Taught Programs', 'Innovation Hub'],
  },
  {
    name: 'New Zealand',
    image: 'https://i.natgeofe.com/n/3c248eb9-9607-430b-8008-0bde5e01a3a8/sleep_GettyImages-520149304_ukHR_16x9.jpg?w=1200', // Replace with actual image path
    highlights: ['Outdoor Adventures', 'Quality Education', 'Safe Environment'],
  },
  // Add more countries here if needed
];

const CountryCard = ({ name, image, highlights }) => {
  const navigate = useNavigate(); // Initialize navigate
  const handleExploreClick = () => {
    // Convert country name to a URL-friendly format (lowercase, replace spaces with hyphens)
    const countrySlug = name.toLowerCase().replace(/\s+/g, '-');
   // console.log("hio explore click check")
    navigate(`/countries/${countrySlug}`); // Programmatically navigate
    //navigate('/countries/canada');
  };
  return (
    <div className="country-card-carousel">
      <img src={image} alt={name} className="country-image-carousel" />
      <h3 className="country-name-carousel">{name}</h3>
      <ul className="country-highlights-carousel">
        {highlights.map((highlight, index) => (
          <li key={index}>{highlight}</li>
        ))}
      </ul>
      <button className="country-explore-button-carousel" onClick={handleExploreClick}>Explore {name}</button>
    </div>
  );
};

const CountriesCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true, // Show navigation arrows
    swipeToSlide: true, // Enable swiping to slide multiple at once
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: true,
        },
      },
    ],
  };

  return (
    <div className="countries-carousel-container">
      <Slider {...settings}>
        {countryData.map((country, index) => (
          <CountryCard key={index} {...country} />
        ))}
      </Slider>
    </div>
  );
};

export default CountriesCarousel;